import React from 'react';
import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

type Props = {
  prevCompetenceList?: string[];
  nextCompetenceList?: string[];
};

export function DiffCompetenceList({
  prevCompetenceList,
  nextCompetenceList,
}: Props) {
  const { t } = useTranslation(['carnet', 'common']);
  if (
    [...(nextCompetenceList || []), ...(prevCompetenceList || [])].length == 0
  ) {
    return (
      <ul>
        <li css={[tw`text-sm`, tw`text-muted before:content-['• ']`]}>
          {t('carnet:syncLivret.modal.noCompetenceOnGrade')}
        </li>
      </ul>
    );
  }

  return (
    <ul>
      {nextCompetenceList?.map(competenceName => (
        <li
          key={competenceName}
          css={[
            tw`text-sm`,
            prevCompetenceList?.includes(competenceName)
              ? tw`text-muted before:content-['• ']`
              : tw`text-positive-intense before:content-['+ ']`,
          ]}
        >
          {competenceName}
        </li>
      ))}
    </ul>
  );
}
